import { Table as ChakraTable } from "@chakra-ui/react";
import THead from "./THead";
import TBody from "./TBody";
import ScrollWrapper from "./ScrollWrapper";
import type { TableProps } from "./Table.d";

const Table = ({ rows, headerGroups }: TableProps) => (
  <ScrollWrapper>
    <ChakraTable mb={2} role="table">
      <THead headerGroups={headerGroups} />
      <TBody rows={rows} />
    </ChakraTable>
  </ScrollWrapper>
);

export default Table;
